const TOKEN_KEY = 'daily_reveal_auth_token';
const USER_KEY = 'daily_reveal_user';

/**
 * Extract token from URL query string
 */
export const extractTokenFromUrl = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  if (token) {
    const isInIframe = window.self !== window.top;
    if (!isInIframe) {
      params.delete('token');
      const newUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
    return token;
  }

  return null;
};

/**
 * Validate JWT token format (basic validation)
 */
export const isValidTokenFormat = (token: string): boolean => {
  if (!token) return false;
  const parts = token.split('.');
  return parts.length === 3;
};

/**
 * Decode JWT token payload (without verification)
 */
export const decodeToken = (token: string): any => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Failed to decode token:', error);
    return null;
  }
};

/**
 * Store authentication data
 */
export const storeAuthData = (data: { token: string; user: any }): void => {
  if (data.token) {
    sessionStorage.setItem(TOKEN_KEY, data.token);
  }
  if (data.user) {
    sessionStorage.setItem(USER_KEY, JSON.stringify(data.user));
  }
};

/**
 * Get stored token
 */
export const getStoredToken = (): string | null => {
  return sessionStorage.getItem(TOKEN_KEY);
};

/**
 * Get stored user
 */
export const getStoredUser = (): any | null => {
  const userStr = sessionStorage.getItem(USER_KEY);
  if (!userStr) return null;

  try {
    return JSON.parse(userStr);
  } catch {
    return null;
  }
};

/**
 * Clear all authentication data
 */
export const clearAuthData = (): void => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
};
